import { useState } from "react";
import { baseObj } from "../../../utils/constants";
import CustomerAirlinesList from "./CustomerAirlinesList";

const CustomerAirlinesPage = ({
}) => {
    const [data,setData]=useState<baseObj[]>([]);
    return <CustomerAirlinesList data_list={data}/>;
}
export default CustomerAirlinesPage;